/**
 * @file 产品全景 hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useEffect, useState} from 'react';
import {fetchGetOverview} from '../../api/pages/overviewApi';
import {IBanner, ITeaching, IProductPreview} from './types';

// 预请求
let preRequest: any = {
    fetchGetOverview: fetchGetOverview()
};

const useOverviewHooks = () => {
    const [banner, setBanner] = useState<IBanner>();
    const [productPreview, setProductPreview] = useState<IProductPreview>();
    const [learnTextCard, setLearnTextCard] = useState<ITeaching>();

    useEffect(() => {
        (async () => {
            const fetchFunc = preRequest.fetchGetOverview || fetchGetOverview();
            delete preRequest.fetchGetOverview;

            let res;

            try {
                res = await fetchFunc;
            }
            catch (err) {
                // ignore
            }
            if (res) {
                const pageData = res.body?.result?.pageData || {};
                const b: any = pageData.banner || {};
                const bBtns: any[] = Array.isArray(b.btns) ? b.btns : [];

                setBanner({
                    title: b.title,
                    subtitle: b.subtitle,
                    btns: bBtns.map((btn) => ({
                        label: btn.label,
                        href: btn.href
                    }))
                });

                const pp: any = pageData.productPreview || {};
                const ppGroup: any[] = Array.isArray(pp.group) ? pp.group : [];
                const ppTools: any[] = Array.isArray(pp.supportTools) ? pp.supportTools : [];

                let ppGroupAllItemsNum = (() => {
                    let num = 0;
                    ppGroup.forEach((groupItem) => {
                        if (Array.isArray(groupItem.tabs)) {
                            groupItem.tabs.forEach((tab: any) => {
                                if (Array.isArray(tab.list)) {
                                    num = num + tab.list.length;
                                }
                            });
                        }
                    });
                    return num;
                })();

                setProductPreview({
                    title: pp.title,
                    subtitle: pp.subtitle,
                    group: ppGroup.map((item) => {
                        const tabs: any[] = Array.isArray(item.tabs) ? item.tabs : [];
                        return {
                            title: item.title,
                            text: item.text,
                            icon: item.icon,
                            iconText: item.iconText,
                            tabs: tabs.map((tab) => {
                                const list: any[] = Array.isArray(tab.list) ? tab.list : [];
                                return {
                                    title: tab.title,
                                    icon: tab.icon,
                                    defaultShow: !!tab.defaultShow,
                                    list: list.map((product) => ({
                                        text: product.text,
                                        title: product.title,
                                        extraText: product.extraText,
                                        url: product.url,
                                        target: !!product.target,
                                        zIndex: ppGroupAllItemsNum--
                                    }))
                                };
                            })
                        };
                    }),
                    supportTools: ppTools.map((tool, index, thisArr) => ({
                        title: tool.title,
                        text: tool.text,
                        extraText: tool.extraText,
                        iconUrl: tool.iconUrl,
                        icon: tool.icon,
                        target: !!tool.target,
                        url: tool.url,
                        zIndex: thisArr.length - index - 1
                    }))
                });

                const ltc: any = pageData.learnTextCards || {};
                const ltcList: any[] = Array.isArray(ltc.list) ? ltc.list : [];
                setLearnTextCard({
                    title: ltc.title,
                    subtitle: ltc.subtitle,
                    list: ltcList.map((item) => ({
                        title: item.title,
                        content: item.content,
                        links: {
                            label: item.links?.label,
                            href: item.links?.href
                        }
                    }))
                });
            }
        })();
    }, []);
    return {
        banner,
        productPreview,
        learnTextCard
    };
};

export default useOverviewHooks;
